import React, { forwardRef } from "react";
import styles from "./MenuItem.module.css";

export interface MenuItemProps {
  children: React.ReactNode;
  href?: string;
  [key: string]: any;
}

const MenuItem = forwardRef<HTMLAnchorElement, MenuItemProps>(
  ({ children, href, ...rest }, ref) => {
    return (
      <a href={href} className={styles.MenuItem} ref={ref} {...rest}>
        {children}
      </a>
    );
  },
);

MenuItem.displayName = "MenuItem";

export default MenuItem;
